import React, { Component } from 'react';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Dropdown from 'react-bootstrap/Dropdown';
export default class DeviceCombo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentValue: ""
    }
    this.typing = this.typing.bind(this)
    this.update = this.update.bind(this)
  }
  typing (event) {
    this.update (event.target.value)
  }
  update (newValue) {
    if (typeof this.props?.onChange === 'function') this.props.onChange(newValue)
    this.setState({currentValue: newValue})
  }
  render() {
    const list = this.props?.options??[]
    const label = this.props?.label ?? ''
    return (
      <span className="inputPair">
      <label htmlFor="deviceid">{label}</label>
      <Dropdown as={ButtonGroup}>
        <input type="text" id="deviceid" name="deviceid" placeholder='Select Radio Id' value={this.state.currentValue} onChange={this.typing}/>
        <Dropdown.Toggle split variant="success" id="dropdown-split"/>
        <Dropdown.Menu>
          {list.map(item =>
            <Dropdown.Item key={item} onClick={()=>this.update(item)}>{item}</Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
      </span>      
    );
  }
}

